import ApiRequest from "../utils/ApiRequest";
// import GlobalData from "../util/GlobalData";

export default class Program {
    getAll = async () => {
        return await ApiRequest.set(`/v1/program/list-program`, "GET");
    }
}